import { ChangeEvent, ReactNode } from 'react';
import { Select, Box } from '@nimbus-ds/components';
import { ErrorMessage } from './ErrorMessage';
import { FormField } from './FormField';

interface FormSelectProps {
  label: string;
  id: string;
  name: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  error?: string;
  isLoading?: boolean;
  disabled?: boolean;
  children: ReactNode;
}

export function FormSelect({
  label,
  id,
  name,
  value,
  onChange,
  error,
  isLoading = false,
  disabled = false,
  children,
}: Readonly<FormSelectProps>) {
  return (
    <FormField label={label}>
      {isLoading ? (
        <Box width="100%">
          <Select.Skeleton />
        </Box>
      ) : (
        <>
          <Select
            id={id}
            name={name}
            value={value}
            onChange={onChange}
            appearance={error ? 'danger' : 'neutral'}
            disabled={disabled}
          >
            {children}
          </Select>
          <ErrorMessage error={error} />
        </>
      )}
    </FormField>
  );
}
